module.exports = function(it, Constructor, name){
  if(!(it instanceof Constructor))throw TypeError(name + ": use the 'new' operator!");
  return it;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/$.strict-new.js
 ** module id = 37
 ** module chunks = 0
 **/